import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react'

const Success = () => {
    const isMobile = useMediaQuery("(max-width:600px)");
    const styles = {
        container: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: isMobile ? "1rem" : "2rem 6rem",
          marginTop: "1rem",
          backgroundColor: "#F7F3FC",
          flexDirection: isMobile ? "column" : "row",
        },
        textContainer: {
          textAlign: "center",
          marginBottom: isMobile ? "1rem" : "0",
        },
        volunteers: {
          fontSize: isMobile ? "24px" : "50px",
          fontWeight: "bold",
          color: "#007bff",
          marginBottom: "10px",
        },
      
    };
  return (
    <div style={{ paddingTop: isMobile ? "3rem" : "6rem", minHeight: "100vh" }}>
        <Box sx={styles.container}>
        <Grid item xs={12} md={12} sx={styles.textContainer}>
            <Typography sx={styles.volunteers}>Volunteers Add successfully</Typography>
            
          </Grid>
        </Box>
      </div>
      
  )
}

export default Success
